<template>
  <div v-loading="loading">
    <div style="margin-bottom: 20px">
      <strong>开启牌局内红包雨：</strong>
      <el-switch
        style="margin-right: 80px"
        @change="statusChange"
        :value="redPack.status"
        :active-value="1"
        :inactive-value="0"
      />

      <strong>单日赠送金豆限额：</strong>
      <input-set-value
        :defaultValue="redPack.countLimit / 100"
        unit="金豆"
        width="150px"
        @my-submit="updateCountLimit"
      />
    </div>
    <el-card>
      <div slot="header">
        <el-date-picker
          v-model="date"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
        <el-button @click="getTotal" style="margin-left: 15px" type="primary">查询</el-button>
      </div>
      <div style="line-height: 40px">
        <p v-text="`赠送玩家数：${playNum}`"></p>
        <p v-text="`赠送金豆数：${totalChip / 100} 金豆`"></p>
      </div>
    </el-card>
    <div v-if="show" class="common-popup-bg">
      <div class="common-popup">
        <h3>谷歌验证</h3>
        <table class="common-popup-table">
          <tr>
            <td><el-input placeholder="请输入谷歌验证码" v-model="code"></el-input></td>
          </tr>
        </table>
        <footer>
          <el-button size="small" @click="closeMsgCode">取消</el-button>
          <el-button size="small" @click="submitMsgCode" type="primary">确定 </el-button>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import inputSetValue from 'components/inputSetValue';

export default {
  components: {
    inputSetValue,
  },
  data() {
    return {
      loading: false,
      show: false,
      statusChangeValue: null, //将要改变的值
      code: '',
      date: null,
      playNum: 0,
      totalChip: 0,
    };
  },
  computed: {
    ...mapState('activity', ['redPack']),
  },
  created() {
    this.getDetail();
  },
  methods: {
    ...mapActions('other', ['sendCodeToMyPhone']),
    ...mapActions('activity', [
      'getRedPack',
      'updateRedPackLimit',
      'updateRedPackStatus',
      'getRedPackTotal',
    ]),
    getDetail() {
      this.loading = true;
      this.getRedPack().then(() => {
        this.loading = false;
      });
    },
    getTotal() {
      if (!this.date) {
        this.$message.error('请选择日期');
        return;
      }
      this.getRedPackTotal({
        start: this.date[0],
        end: this.date[1],
      }).then((res) => {
        this.playNum = res.data.playNum;
        this.totalChip = res.data.totalChip;
      });
    },
    updateCountLimit({ value, cb }) {
      if (value < 0) {
        this.$message.error('限额不能小于0');
        return;
      }
      this.updateRedPackLimit({
        id: this.redPack.id,
        accountLimit: value * 100,
      }).then(() => {
        cb();
        this.$message.success('修改成功');
        this.getDetail();
      });
    },
    statusChange(value) {
      this.statusChangeValue = value;
      this.show = true;
    },
    // 发送短信
    sendCodeFunc(e) {
      //关闭16 启用17
      let type = this.statusChangeValue ? 17 : 16;
      this.sendCodeToMyPhone({ err: e.err, type });
    },
    submitMsgCode() {
      if (!this.code) {
        this.$message.error('请输入谷歌验证码');
        return;
      }
      this.updateRedPackStatus({
        id: this.redPack.id,
        code: this.code,
        status: this.statusChangeValue,
      }).then(() => {
        this.$message.success('修改成功');
        this.closeMsgCode();
        this.getDetail();
      });
    },
    closeMsgCode() {
      this.code = '';
      this.show = false;
    },
  },
};
</script>
